/** MIME-тип для drag-and-drop блока библиотеки на таймлайн (см. CONTRACT.md). */
export const SEGMENT_DND_MIME = 'application/x-segment-id';
